import React from 'react';
// redux
import { connect } from 'react-redux';
import { deleteSkill } from '../../../redux/reducers/skills';
// components
import Button from '../../../components/Button/Button';
// utils
import { toastResponseErrors } from '../../../utils/response';
// styles
import styles from './DeleteSkill.mod.css';
import { closeModal } from '../../../redux/reducers/modal';

const DeleteSkill = ({
  closeModal,
  modalData: { skill, color },
  deleteSkill
}) => {
  const { id, title } = skill;
  const submitDelete = () => {
    deleteSkill({ id })
      .then(() => {
        closeModal();
      })
      .catch(toastResponseErrors);
  };

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>Delete Skill</h2>
      <div className={styles.info}>
        <p className={styles.label}>
          Are you sure you want to delete this skill?
        </p>
        <span>{title}</span>
      </div>
      <div className={styles.buttonSection}>
        <Button plain onClick={closeModal}>
          Cancel
        </Button>
        <Button type="submit" color={color} onClick={submitDelete}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export default connect(
  null,
  { deleteSkill, closeModal }
)(DeleteSkill);



// WEBPACK FOOTER //
// ./src/containers/Skills/components/DeleteSkill.jsx